// inProgressMealPlan.js - Utilities for managing in-progress meal plan in localStorage

const STORAGE_KEY = 'inProgressMealPlan';

/**
 * Save in-progress meal plan data to localStorage
 */
export const saveInProgressMealPlan = (data) => {
  try {
    const payload = {
      mealPlan: data.mealPlan || [],
      productList: data.productList || [],
      totalCost: data.totalCost, // Don't default to '' - preserve actual value
      adjustedTotalCost: data.adjustedTotalCost, // Don't default to null - preserve actual value  
      maxStorageTime: data.maxStorageTime || 5,
      leftovers: data.leftovers || [],
      haveItState: data.haveItState || {},
      timestamp: Date.now()
    };
    console.log('[inProgressMealPlan] Saving to localStorage:', {
      totalCost: payload.totalCost,
      adjustedTotalCost: payload.adjustedTotalCost,
      productListLength: payload.productList.length
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.error('Error saving in-progress meal plan:', error);
  }
};

/**
 * Get in-progress meal plan from localStorage
 * Returns null if no data or data is stale (older than 1 hour)
 */
export const getInProgressMealPlan = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    
    const data = JSON.parse(stored);
    
    console.log('[inProgressMealPlan] Reading from localStorage:', {
      totalCost: data.totalCost,
      adjustedTotalCost: data.adjustedTotalCost,
      productListLength: data.productList?.length || 0,
      mealPlanLength: data.mealPlan?.length || 0
    });
    
    // Check if data is stale (older than 1 hour)
    const ONE_HOUR = 60 * 60 * 1000;
    if (Date.now() - data.timestamp > ONE_HOUR) {
      console.log('[inProgressMealPlan] Data is stale, clearing');
      clearInProgressMealPlan();
      return null;
    }
    
    // Check if there's actually meal plan data
    if (!data.mealPlan || data.mealPlan.length === 0) {
      console.log('[inProgressMealPlan] No meal plan data');
      return null;
    }
    
    return data;
  } catch (error) {
    console.error('Error reading in-progress meal plan:', error);
    return null;
  }
};

/**
 * Check if there's a valid in-progress meal plan
 */
export const hasInProgressMealPlan = () => {
  return getInProgressMealPlan() !== null;
};

/**
 * Update only haveItState in the existing localStorage data (partial update).
 * No-op if no saved data exists.
 */
export const updateHaveItStateInStorage = (haveItState) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return;
    const data = JSON.parse(stored);
    data.haveItState = haveItState || {};
    data.timestamp = Date.now();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Error updating haveItState in localStorage:', error);
  }
};

/**
 * Clear in-progress meal plan from localStorage
 */
export const clearInProgressMealPlan = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing in-progress meal plan:', error);
  }
};
